// components/Toast.js
import React, { useEffect, useState } from "react";

const icons = {
  success: "✅",
  error: "❌",
  warning: "⚠️",
  info: "ℹ️",
};

function Toast({
  message,
  type = "success",
  onClose,
  duration = 2200,
  position = "bottom-right",
}) {
  const [leaving, setLeaving] = useState(false);

  // Handle fade-in and fade-out
  useEffect(() => {
    if (!message) return;
    setLeaving(false); // Reset for new toast
    const timer = setTimeout(() => setLeaving(true), duration);
    return () => clearTimeout(timer);
  }, [message, duration]);

  // After fade-out, actually close the toast
  useEffect(() => {
    if (!leaving) return;
    const leaveTimer = setTimeout(onClose, 330); // match toastFadeOut duration
    return () => clearTimeout(leaveTimer);
  }, [leaving, onClose]);

  if (!message) return null;

  return (
    <div
      className={`toast toast-${type}${leaving ? " toast-leave" : ""} toast-pos-${position}`}
      role="alert"
      aria-live="assertive"
      tabIndex={0}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "0.7em",
        minWidth: 220,
        maxWidth: 320,
        padding: "14px 18px",
        fontSize: "1.05rem",
        borderRadius: 8,
        border: "1.5px solid #aaa5",
        color: "#252525",
        boxShadow: "0 4px 24px #3331",
        zIndex: 'var(--z-toast)',
        background:
          type === "success"
            ? "#eafae7"
            : type === "error"
            ? "#ffeaea"
            : type === "warning"
            ? "#fff8e1"
            : "#eaf4fd",
        position: "fixed",
        ...(position === "bottom-right"
          ? { bottom: 30, right: 32 }
          : position === "top-center"
          ? { top: 32, left: "50%", transform: "translateX(-50%)" }
          : { bottom: 30, left: 32 }), // fallback: bottom-left
      }}
    >
      <span aria-hidden="true" style={{ fontSize: 22 }}>
        {icons[type] || icons.info}
      </span>
      <span style={{ flex: 1 }}>{message}</span>
      <button
        style={{
          border: "none",
          background: "transparent",
          cursor: "pointer",
          fontSize: 18,
          color: "#666",
          marginLeft: 6,
        }}
        aria-label="Close"
        onClick={() => setLeaving(true)}
        tabIndex={0}
      >
        ×
      </button>
    </div>
  );
}

export default Toast;
